import { UNIVERSITY } from '~/consts'
import { v4 as uuidv4 } from 'uuid';

export default async function ({ req, redirect, app, route, store }) {
  let token = route.query.t;
  const cookies = app.$cookies;
  let host = null
  let subdomain = null
  let no_need_encode = false;
  let is_embed = !helpers.isEmpty(route.name) && !helpers.isEmpty(route.name.split('-')) && route.name.split('-')[0] == 'embed';

  if (process.browser) {
    if (!is_embed) {
      let eid = cookies.get('_eid')

      if (helpers.isEmpty(eid)) {
        eid = uuidv4();

        cookies.set('_eid', eid)
      }
    }
  }

  // Define token need encode or not
  try {
    no_need_encode = helpers.parseJwt(token)
    no_need_encode = !helpers.isEmpty(no_need_encode) && !helpers.isEmpty(no_need_encode.username) && !helpers.isEmpty(no_need_encode.appid)
  } catch (e) {
  }

  host = process.server ? req.headers.host : window.location.host;

  // check domain is local or custom like "https://elearning.online.course"
  if (!helpers.isEmpty(host)) {

    if (!host.includes('localhost')) {
      if (host.includes(process.env.WEB_HOST)) {
        // Check for subdomain
        subdomain = !helpers.isEmpty(host.split('.')[1]) && host.split('.')[1].includes('localhost') ? host.split('.')[0] : (host.split('.')[2] ? host.split('.')[0] : null);
        if (!helpers.isEmpty(subdomain) && isNaN(parseInt(subdomain))) {
          if (subdomain != 'staging') {
            // GET UNIVERSITY DATA
            let { data } = await app.$axios.post(UNIVERSITY.GET_PUBLIC_SINGLE(subdomain));

            if (data.applicationSystem.code == 0) {
              store.commit('universities/setState', {key: 'active', value: data.data})
            }
          }
        }
      } else {
        let { data } = await app.$axios.post(UNIVERSITY.GET_PUBLIC_SINGLE(host) + '?ish=1');

        if (data.applicationSystem.code == 0) {
          store.commit('universities/setState', {key: 'active', value: data.data})
        }
      }
    }

    if (token) {
      if (!is_embed) {
        cookies.set('token', token, {
          path: '/',
          expires: helpers.getDateOfTokenExpires(),
        });

        let query = {...route.query}

        if (!helpers.isEmpty(query.t)) {
          delete query.t;
          return redirect({path: route.path, query})
        }
      }
    }
  }
}
